module.exports = __webpack_public_path__ + "img/tren.ef4471a0.jpg";